import { MenuKey } from '@tbbt/shared';

/**
 * The footer's three menu columns, and the headings a visitor actually reads.
 *
 * Shared, because two screens render these columns: the public footer and the admin's menu
 * preview. This is the only place the visitor-facing names exist.
 *
 * They are deliberately **not** `MENU_LABELS` from `@tbbt/shared`, which calls the first
 * column "Footer — Solutions" — a phrase that appears nowhere on the public site. The admin
 * console used to print that label with "The Services column at the foot of every page"
 * directly underneath it, so the screen contradicted itself in adjacent lines and only the
 * second line was true. One source means a rename lands in both places or neither.
 *
 * In a module of its own rather than exported from `PublicLayout`: a non-component export
 * from a file full of components disables Vite's fast refresh for that whole file, and the
 * public layout is edited often enough for that to be felt.
 */
export const FOOTER_COLUMNS = [
  { key: MenuKey.FOOTER_SOLUTIONS, heading: 'Services' },
  { key: MenuKey.FOOTER_COMPANY, heading: 'Company' },
  { key: MenuKey.FOOTER_LEGAL, heading: 'Legal' },
] as const;
